import { DEFAULT_TOAST_LIFE } from "../../../common/EzToast";
import {
  FETCH_COMPANY_DETAIL,
  INIT_COMPANY,
  FETCH_COMPANY_LIST_START,
  FETCH_COMPANY_LIST_SUCCESS,
  FETCH_COMPANY_LIST_ERROR,
  TOAST,
  FETCH_CUSTOMER_LIST_START,
  FETCH_CUSTOMER_LIST_SUCCESS,
  FETCH_CUSTOMER_LIST_ERROR,
  CREATE_COMPANY_RECORD,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  INIT_CREATE_COMPANY_SCREEN
} from "../../../constants/action-types/company";
import { companyService, complianceService } from "../../../Services";
import { goBack } from "../../../utils/gotoback";
import { resetToast } from "../manage-card";

export const initializeCompanyScreen = () => ({ type: INIT_COMPANY });

export const setDeleteConfirmationPopupVisibility = (payload) => ({
  type: SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  payload,
});

export const createCompanyScreenInitStart = (payload) => ({
  type: INIT_CREATE_COMPANY_SCREEN,
  payload,
});

export const initCreateCompanyScreen = (payload) => {
  return (dispatch) => {
    dispatch(createCompanyScreenInitStart());
  };
};

export const companyFetchStart = (payload) => ({

  type: FETCH_COMPANY_LIST_START,
  payload,
});

export const companyFetchSuccess = (payload) => ({
  type:FETCH_COMPANY_LIST_SUCCESS,
  payload,
});

export const companyFetchError = (payload) => ({
  type: FETCH_COMPANY_LIST_ERROR,
  payload,
});

export const fetchCompany = (payload) => {
  return (dispatch) => {
    dispatch(companyFetchStart(payload));

    companyService.fetchCompany(payload).then((data) => {
      let nData = {
        page:1,
        content:[data]
      };
      if (!data.isError) {
        dispatch(companyFetchSuccess(nData));
      
      } else {
        dispatch(companyFetchError(data));
      }
    });
  };
};

// Fetch Customers
export const customerFetchStart = (payload) => ({
  type: FETCH_CUSTOMER_LIST_START,
  payload,
});

export const customerFetchSuccess = (payload) => ({
  type: FETCH_CUSTOMER_LIST_SUCCESS,
  payload,
});

export const customerFetchError = (payload) => ({
  type: FETCH_CUSTOMER_LIST_ERROR,
  payload,
});

export const fetchCustomers = (payload) => {
  return (dispatch) => {
    dispatch(customerFetchStart(payload));

    companyService.fetchCustomers(payload).then((data) => {
      if (!data.isError) {
        dispatch(customerFetchSuccess(data));
      } else {
        dispatch(customerFetchError(data));
      }
    });
  };
};


export const createCompanyRecordStart = (payload) => ({
  type: CREATE_COMPANY_RECORD.START,
  payload
});

export const createCompanyRecordSuccess = (payload) => ({
  type: CREATE_COMPANY_RECORD.SUCCESS,
  payload,
});

export const createCompanyRecordError = (payload) => ({
  type: CREATE_COMPANY_RECORD.ERROR,
  payload,
});

export const createCompany = (payload) => {
  return (dispatch) => {
    dispatch(createCompanyRecordStart());
    companyService.createCompany(payload).then((data) => {
      if (!data.isError) {
        dispatch(createCompanyRecordSuccess());
        goBack();
      } else {
        dispatch(createCompanyRecordError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};